export const reportContentConstants = {

    // REQUEST_REPORT_CONTENT
    REQUEST_REPORT_CONTENT: 'REQUEST_REPORT_CONTENT',
    RECEIVE_REPORT_CONTENT: 'RECEIVE_REPORT_CONTENT',
    REPORT_CONTENT_ERROR: 'REPORT_CONTENT_ERROR',

    //  REQUEST_ORIENTATION_LIST
    REQUEST_ORIENTATION_LIST: 'REQUEST_ORIENTATION_LIST',
    RECEIVE_ORIENTATION_LIST: 'RECEIVE_ORIENTATION_LIST',
    ORIENTATION_LIST_ERROR: 'ORIENTATION_LIST_ERROR',

    // REQUEST_SLOT_LIST
    REQUEST_SLOT_LIST:'REQUEST_SLOT_LIST',
    RECEIVE_SLOT_LIST:'RECEIVE_SLOT_LIST',
    SLOT_LIST_ERROR:'SLOT_LIST_ERROR',
 
};



// WEBPACK FOOTER //
// ./src/_constants/reportContent.constants.js